import clsx from 'clsx'
import { Fragment, type ReactNode } from 'react'

import { Placeholder, PlaceholderLine, PlaceholderMedia } from '@/src/elements/placeholder'

import { ItemSeparatorComponent } from './ItemSeparatorComponent'
import { prayerRowHeightClassName } from './PrayersList/PrayerRow'

export const PrayerRowPlaceholder = (): ReactNode => (
  <>
    {Array.from({ length: 3 }, (_, index) => (
      <Fragment key={index}>
        <ItemSeparatorComponent />
        <Placeholder noBackground className={clsx('items-center px-0 py-0', prayerRowHeightClassName)}>
          <PlaceholderMedia size="avatar-md" contrast="dark" />
          <PlaceholderLine size="md" contrast="dark" className="ml-4 max-w-44" />
        </Placeholder>
      </Fragment>
    ))}
  </>
)
